import { API, AUTH } from "../store";
import { openSnackBar } from "./snack-bar";
import serialize from "../store/serialize";
import handleCatch from "../lib/catch";
import { updateCrewMember } from "./crew";
import { updateLoggedInUser, doRefresh } from "./authentication";
import fetch from "isomorphic-fetch";
import cloudinary from "cloudinary";
import base64 from "base-64";
// import cloudinary from 'cloudinary'

export const updatingUser = (updatingUser = true) => ({
  type: "USER::UPDATING_USER",
  updatingUser,
});

export const _updateEditUser = (updates = {}) => ({
  type: "USER::UPDATE",
  updates,
});

export const _setEditUser = (data = {}) => ({
  type: "USER::SET",
  data,
});

export const toggleProfileDialog = (profileDialogOpen = false, editUser) => ({
  type: "USER::TOGGLE_PROFILE_DIALOG",
  profileDialogOpen,
  editUser,
});

export const toggleCreateUserDialog = (
  createUserDialogOpen = false,
  editUser
) => ({
  type: "USER::TOGGLE_CREATE_USER_DIALOG",
  createUserDialogOpen,
  editUser,
});

export const _updateUser = (updates) => {
  return (dispatch) => {
    dispatch(_updateEditUser(updates));
    dispatch(updateCrewMember(updates));
    dispatch(updateLoggedInUser(updates));
  };
};

export const getUser = (id, isAuth) => {
  return (dispatch) => {
    const deferred = new Promise((resolve, reject) => {
      const call = (isAuth) => {
        let agent = API;
        if (isAuth) {
          agent = AUTH;
        }
        agent
          .get(`/users/${id}`)
          .then((response) => response.body)
          .then((response) => {
            if (response.message === "users get success") {
              serialize("user", response.data).then((response) => {
                resolve(response);
              });
            } else {
              reject("not found");
            }
          })
          .catch((err) => {
            handleCatch(err, dispatch)
              .then(() => call(isAuth))
              .catch(reject);
          });
      };
      call(isAuth);
    });
    return deferred;
  };
};

export const getUserByPhone = (phone) => {
  return (dispatch, getState) => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/users/${phone}/exists`)
          .then((response) => response.body)
          .then((response) => {
            if (response.message === "user exists") {
              dispatch(getUser(response.data.id, true))
                .then((getUserResponse) => {
                  resolve(getUserResponse);
                })
                .catch(reject);
            } else {
              reject("user does not exist");
            }
          })
          .catch((err) => {
            handleCatch(err, dispatch)
              .then(() => call())
              .catch(reject);
          });
      };
      call();
    });
    return deferred;
  };
};

export const checkUserByPhone = (phoneRaw) => (dispatch, getState) => {
  let phone;
  if (phoneRaw.substring(0, 2) === "+1") {
    phone = phoneRaw;
  } else if (phoneRaw.substring(0, 1) === "1") {
    phone = `+${phoneRaw}`;
  } else {
    phone = `+1${phoneRaw}`;
  }
  const deferred = new Promise((resolve, reject) => {
    const call = () => {
      API.get(`/users/${phone}/exists`)
        .then((response) => response.body)
        .then((response) => {
          if (response.message === "user exists") {
            resolve(response.data);
          } else {
            reject("user does not exist");
          }
        })
        .catch((err) => {
          handleCatch(err, dispatch)
            .then(() => call())
            .catch(reject);
        });
    };
    call();
  });
  return deferred;
};

export const deleteContact = (contactId, data) => (dispatch, getState) => {
  const deferred = new Promise((resolve, reject) => {
    const call = () => {
      API.delete(
        `/users/${
          getState().authentication.authenticatedUser.id
        }/contacts/${contactId}?contacts_id=${data.contacts_id}&delay=${
          data.delay
        }&title=${data.title}`
      )
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.body)
        .then((response) => {
          if (response.message === "users delete contact success") {
            dispatch(
              openSnackBar({
                message: "Contact Deleted",
              })
            );

            resolve(response);
            dispatch(doRefresh());
          } else {
            reject();
          }
        })
        .catch((err) => {
          handleCatch(err, dispatch).then(call).catch(reject);
        });
    };
    call();
  });
  return deferred;
};

export const confirmUser = (data) => {
  return (dispatch, getState) => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        if (data.isEditingUser) {
          API.put(
            `/users/${
              getState().authentication.authenticatedUser.id
            }/contacts/${
              data.isEditingUser ? data.contacts_glue_id.toString() : ""
            }`
          )
            .send(data)
            .then((response) => {
              if (!response.ok) {
                throw Error(response.statusText);
              }
              resolve(response);
              dispatch(doRefresh());
              dispatch(
                openSnackBar({
                  message: "Emergency Contact Updated",
                })
              );
              // return response
            })
            .catch((err) => {
              if (err.response && err.response.body) {
                if (
                  err.response.body.message === "users create contact error" &&
                  err.response.body.error.code === "ER_DUP_ENTRY"
                ) {
                  dispatch(
                    openSnackBar({
                      message: "NO DUPLICATE CONTACTS",
                    })
                  );
                } else {
                  dispatch(
                    openSnackBar({
                      message: "ERROR IN CREATION, LOOK IN BODY",
                    })
                  );
                }
              }
            });
        } else {
          API.post(
            `/users/${
              getState().authentication.authenticatedUser.id
            }/contacts/${
              data.isEditingUser ? data.contacts_glue_id.toString() : ""
            }`
          )
            .send(data)
            .then((response) => {
              if (!response.ok) {
                throw Error(response.statusText);
              }
              resolve(response);
              dispatch(doRefresh());
              dispatch(
                openSnackBar({
                  message: "Emergency Contact Added",
                })
              );
              // return response
            })
            .catch((err) => {
              if (err.response && err.response.body) {
                if (
                  err.response.body.message === "users create contact error" &&
                  err.response.body.error.code === "ER_DUP_ENTRY"
                ) {
                  dispatch(
                    openSnackBar({
                      message: "DUPLICATE CONTACTS NOT ALLOWED",
                    })
                  );
                } else if (
                  err.response.body.message === "users create contact error" &&
                  err.response.body.error === "circular reference"
                ) {
                  dispatch(
                    openSnackBar({
                      message: "CANNOT ADD SELF AS EMERGENCY CONTACT",
                    })
                  );
                } else {
                  dispatch(
                    openSnackBar({
                      message: err,
                    })
                  );
                }
              }
            });
        }
      };
      call();
    });
    return deferred;
  };
};

export const createUser = (data) => {
  console.log(data);
  return (dispatch) => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/users`)
          .send(data)
          .then((response) => response.body)
          .then((response) => {
            if (response.message === "users create success") {
              // dispatch(getUser(response.id)).then(
              //   user => {
              //     resolve(user)
              //   },
              //   function(err) {
              //     reject(err)
              //   }
              // )
              resolve(response);
            } else {
              reject(response.error);
            }
          })
          .catch((err) => {
            handleCatch(err, dispatch).then(call).catch(reject);
          });
      };
      call();
    });
    return deferred;
  };
};

export const addContactUser = (data) => {
  return (dispatch) => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/users`)
          .send(data)
          .then((response) => response.body)
          .then((response) => {
            if (response.message === "users create CONTACT success") {
              resolve(response);
            } else {
              reject(response.error);
            }
          })
          .catch((err) => {
            handleCatch(err, dispatch).then(call).catch(reject);
          });
      };
      call();
    });
    return deferred;
  };
};

export const updateUser = (userId, data) => {
  return (dispatch) => {
    dispatch(updatingUser());
    return API.put(`/users/${userId}`)
      .send(data)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        // dispatch(updatingUser(false))

        return response;
      })
      .then((response) => response.body)
      .then((response) => {
        if (response.message === "users update success") {
          dispatch(
            openSnackBar({
              message: "Profile Updated",
            })
          );
          dispatch(doRefresh());
          dispatch(updatingUser(false));
        }
      });
  };
};

export const updateUserPut = (userId, data, history, role = "", cb) => {
  let phone;
  let phoneRaw = data.phone;
  if (phoneRaw.substring(0, 2) === "+1") {
    phone = phoneRaw;
  } else if (phoneRaw.substring(0, 1) === "1") {
    phone = `+${phoneRaw}`;
  } else {
    phone = `+1${phoneRaw}`;
  }
  data.phone = phone;

  return (dispatch) => {
    dispatch(updatingUser());
    return API.put(`/users/${userId}`)
      .send(data)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(updatingUser(false));
        return response.body;
      })
      .then((response) => {
        if (response.message === "users update success") {
          dispatch(doRefresh());
          dispatch(
            openSnackBar({
              message: "Profile Updated",
            })
          );
          if (role && role === "buyer") {
            cb && cb(response);
          } else if (history) {
            history.push("/checkout");
          }
        }
      });
  };
};

export const ocrUpload = (file) => {
  var encodedData = base64.encode(file);
  return (dispatch) => {
    // const deffered = new Promise((resolve, reject) => {
    // const call = () => {
    cloudinary.v2.uploader.upload(
      "data:" + file.type + ";base64," + encodedData,
      // file.toDataURL(file.type),
      { ocr: "adv_ocr:document" },
      (error, result) => {}
    );
  };
  // call()
  // })
  // return deffered
};

export const addShowingAttendee = (attendeeID, match) => (dispatch) => {
  const attendeeObj = {
    users_id: attendeeID,
  };
  API.post(`/events/${match.params.id}/attendees`)
    .send(attendeeObj)
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
    .then((res) => res.body)
    .then((data) => {
      if (data.message === "events create attendee success") {
        dispatch(doRefresh); // ?
      } else {
        throw new Error("FAILED TO CREATE EVENT");
      }
    })
    .catch((err) => console.log("err", err));
};

export const deleteShowingAttendee = (attendeeID, match) => (dispatch) => {
  const attendeeObj = {
    users_id: attendeeID,
  };
  API.post(`/events/${match.params.id}/attendees`)
    .send(attendeeObj)
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
    .then((res) => res.body)
    .then((data) => {
      if (data.message === "events delete attendee success") {
        dispatch(doRefresh); // ?
      } else {
        throw new Error("FAILED TO CREATE EVENT");
      }
    })
    .catch((err) => console.log("err", err));
};

const googleComponents = [
  { googleComponent: `sublocality_level_1`, key: `city` },
  { googleComponent: `locality`, key: `city` },
  { googleComponent: `administrative_area_level_1`, key: `state` },
  { googleComponent: `postal_code`, key: `zip` },
  { googleComponent: `street_number`, key: `street_number` },
  { googleComponent: `route`, key: `route` },
  { googleComponent: `country`, key: `country` },
];

const populateObject = (addressComponent, formMap, obj) => {
  const addressType = addressComponent.types[0];
  formMap.map((x) =>
    x.googleComponent === addressType
      ? (obj[x.key] = addressComponent.long_name)
      : null
  );
};

export const getAddress = (lat, lng, func) => (dispatch) => {
  fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_GEOENCODING_API_KEY}`
  )
    .then((res) => res.json()) // returns results array of best guess absed off your lat and lng
    .then((data) => {
      if (data.status === "OK" && data.results && data.results.length > 0) {
        //send array of components to API
        const address = data.results[0].formatted_address; // ex. "685 Johnnie Dodds Blvd, Mt Pleasant, SC 29464, USA"

        if (document.getElementById("autocomplete")) {
          document.getElementById("autocomplete").value = address;
        }
        const obj = {};

        //mutates obj
        data.results[0].address_components.map((x) =>
          populateObject(x, googleComponents, obj)
        );
        // passes addressobj
        func(true, address, obj);
        // return obj
      } else {
        //error
      }
    })
    .catch((err) => console.log("err", err));
};

export const getLatLng = (address, handleOnChange, bool) => (dispatch) => {
  fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${process.env.REACT_APP_GOOGLE_GEOENCODING_API_KEY}`
  )
    .then((res) => res.json()) // returns results array of best guess absed off your lat and lng
    .then((data) => {
      if (data.status === "OK" && data.results && data.results.length > 0) {
        //send array of components to API
        const address = data.results[0].formatted_address; // ex. "685 Johnnie Dodds Blvd, Mt Pleasant, SC 29464, USA"

        // document.getElementById('autocomplete').value = address
        const obj = {};
        // const newLatLng = {}

        //mutates obj
        data.results[0].address_components.map((x) =>
          populateObject(x, googleComponents, obj)
        );
        obj.lat = data.results[0].geometry.location.lat;
        obj.lng = data.results[0].geometry.location.lng;
        // passes addressobj
        handleOnChange(bool, address, obj);
        return obj;
      } else {
        //error
      }
    })
    .catch((err) => console.log("err", err));
};

export const getAddressForPanic = (lat, lng) => (dispatch) => {
  console.log("ghjgighiu");
  return new Promise((resolve, reject) => {
    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_GEOENCODING_API_KEY}`
    )
      .then((res) => res.json()) // returns results array of best guess absed off your lat and lng
      .then((data) => {
        if (data.status === "OK" && data.results && data.results.length > 0) {
          //send array of components to API

          const obj = {};

          //mutates obj
          data.results[0].address_components.map((x) =>
            populateObject(x, googleComponents, obj)
          );
          // passes addressobj
          resolve(obj);
          // return obj
        } else {
          //error
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const doPanic = (data) => (dispatch, getState) => {
  navigator.geolocation.getCurrentPosition(
    async (position) => {
      let lat = position.coords.latitude;
      let lng = position.coords.longitude;

      dispatch(getAddressForPanic(lat, lng)).then((addressObject) => {
        API.post("/users/panic")
          .send({ ...addressObject })
          .then((res) => res.body)
          .then((res) => {
            if (res.message === "users panic success") {
              dispatch(
                openSnackBar({
                  message: "Contacts Notified With Your Location",
                })
              );
            } else {
              dispatch(
                openSnackBar({
                  message: "Error notifying all contacts",
                })
              );
            }
          })
          .catch((err) => console.log("err panic", err));
      });
    },
    (err) =>
      API.post("/users/panic")
        .send({})
        .then((res) => res.body)
        .then((res) => {
          if (res.message === "users panic success") {
            dispatch(
              openSnackBar({
                message: "Contacts Notified With Your Location",
              })
            );
          } else {
            dispatch(
              openSnackBar({
                message: "Error notifying all contacts",
              })
            );
          }
        })
        .catch((err) => console.log("err panic", err))
  );
};

export const toggleRequiredLicense = (bool) => (dispatch, getState) => {
  const { id } = getState().authentication.authenticatedUser;
  //db requires binary boolean

  API.put(`/users/${id}`)
    .send({
      license_required: bool ? 1 : 0,
    })
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      if (response.body.message === "users update success") {
        // dispatch({
        //   type: 'REQUIRED_LICENSE_TOGGLED',
        //   payload: bool
        // })
        //
        // ! Updates UI to show toggle state
        dispatch(doRefresh());
        // dispatch(
        //   openSnackBar({
        //     message: `Licence's are now ${bool ? 'Required' : 'not Required'}`
        //   })
        // )
      }
    });
};

export const addRealtor = (data, userId, isEditMode) => {
  return (dispatch) => {
    const deferred = new Promise((resolve, reject) => {
      const method = isEditMode ? "put" : "post";
      let endPoint = "/users";
      if (isEditMode && userId) {
        endPoint += `/${userId}`;
      }
      API[method](endPoint)
        .send(data)
        .then((res) => res.body)
        .then((res) => {
          dispatch(
            openSnackBar({
              message: isEditMode
                ? "Realtor updated successfully"
                : "Realtor added successfully",
            })
          );
          resolve(res);
        })
        .catch((err) => {
          console.error("Error while adding realtor");
          reject(err);
        });
    });
    return deferred;
  };
};

export const getReviewRating =
  (userId, pageNumber, pageSize = 20) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      API.get(`/users/rating-review-list/${userId}`)
        .query({ pageNumber: pageNumber })
        .query({ pageSize: pageSize })
        .then((res) => {
          if (!res.ok) throw Error(res.statusText);
          return res.body;
        })
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  };
